import { takeLatest, fork, call, put } from 'redux-saga/effects'

import { showSpinner, hideSpinner } from '../../modules/global/actions'
import { ApiRequest } from '../../utils/api';
import { doCallApi } from '../global/sagas'
import {
    CUSTOMER_DATA_FETCH,
    CUSTOMER_DATA_UPDATE,
} from './constants'
import { fetchCustomerDataSuccess, updateCustomerFinished } from './actions'
import { getAccountId } from '../../utils/helpers';

export function* fetchCustomerData() {
  yield put(showSpinner());

  const { response } = yield call(doCallApi, true, ApiRequest.loadCustomerData, getAccountId());

  if (response) {
    yield put(fetchCustomerDataSuccess(response))
  }
  yield put(hideSpinner())
}

function* updateCustomerData(action) {
  yield put(showSpinner());
  const accountiD = getAccountId();
  const { response } = yield call(doCallApi, true, ApiRequest.updateCustomer, action.payload, accountiD)
  if (response) {
    yield put(fetchCustomerDataSuccess(response))
    yield put(updateCustomerFinished())
  }
  yield put(hideSpinner())
}

/**
 * Start
 */
export function* root() {
  yield fork(takeLatest, CUSTOMER_DATA_FETCH, fetchCustomerData);
  yield fork(takeLatest, CUSTOMER_DATA_UPDATE, updateCustomerData);
}

export default [
  root,
];
